import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import { GET_GIT_ROOTS_FILTER_OPTIONS } from "../../queries";
import { Logger } from "utils/logger";

const useGitRootFilterOptionsQuery = (
  groupName: string,
): {
  gitBranches: string[];
  gitNickNames: string[];
  loadingFiltersData: boolean;
} => {
  const { data: gitRootsFiltersData, loading: loadingFiltersData } = useQuery(
    GET_GIT_ROOTS_FILTER_OPTIONS,
    {
      fetchPolicy: "network-only",
      nextFetchPolicy: "cache-first",
      onError: ({ graphQLErrors }): void => {
        graphQLErrors.forEach((error): void => {
          Logger.error("Couldn't load toe inputs components", error);
        });
      },
      variables: { groupName },
    },
  );

  const gitNickNames = useMemo((): string[] => {
    return gitRootsFiltersData?.group.gitRootsNicknames ?? [];
  }, [gitRootsFiltersData]);

  const gitBranches = useMemo((): string[] => {
    return gitRootsFiltersData?.group.gitRootsBranch ?? [];
  }, [gitRootsFiltersData]);

  return { gitBranches, gitNickNames, loadingFiltersData };
};

export { useGitRootFilterOptionsQuery };
